import {Button, ButtonText, FormField, Input, InputField, Text, VStack} from "@hosttools/frontend";
import type {ChannelObject} from "@hosttools/frontend/models/channel";
import type {FC} from "react";
import {useEffect, useState} from "react";

import type {Errors} from "./types";

interface Props {
    channel: ChannelObject;
    method: string;
    errors: Errors;
    buttonText: string;
    onChange: (code: string) => void;
    onSubmit?: () => void;
}

const Code: FC<Props> = props => {
    const {channel, method, errors: propErrors, onChange, onSubmit, buttonText} = props;
    const [code, setCode] = useState("");
    const [errors, setErrors] = useState(propErrors);

    useEffect(() => {
        setErrors(propErrors);
    }, [propErrors]);

    function handleChangeCode(code: string) {
        setCode(code);
        onChange(code);
    }

    return (
        <VStack space="xl">
            <Text>
                {channel.label} has sent you a code to <b>{method}</b>, please enter it below.
            </Text>
            <FormField
                error={errors.verificationCode}
                label={`${channel.label} Verification Code`}
                tooltip={`Enter the verification code that was sent to you by ${channel.label}`}
            >
                <Input>
                    <InputField
                        id="code"
                        name="code"
                        placeholder={`${channel.label} Verification Code...`}
                        type="text"
                        value={code}
                        onChangeText={handleChangeCode}
                    />
                </Input>
            </FormField>
            <Button className="md:hidden" onPress={onSubmit}>
                <ButtonText>{buttonText}</ButtonText>
            </Button>
        </VStack>
    );
};

export default Code;
